import guards from '../../guards';

export default [
  {
    path: 'home',
    name: 'Home',
    redirect: { name: 'Dashboard' },
  },
  {
    path: 'debts-calendar',
    name: 'DebtsCalendar',
    component: () => import(/* webpackChunkName: "debts-calendar" */ '../../../views/Admin/DebtsCalendar.vue'),
  },
  {
    path: 'dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../../../views/Admin/Dashboard.vue'),
  },
  {
    path: 'invoices',
    name: 'InvoicesHistoryRefactor',
    component: () => import(/* webpackChunkName: "invoices-history-refactor" */ '../../../views/Admin/Invoices/History.vue'),
  },
  {
    path: 'invoices-history',
    name: 'InvoicesHistory',
    redirect: { name: 'InvoicesHistoryRefactor' },
    component: () => import(/* webpackChunkName: "invoices-history" */ '../../../views/Admin/Invoices/History/index.vue'),
    children: [
      {
        path: 'stamped',
        name: 'StampedList',
        redirect: { name: 'InvoicesHistoryRefactor' },
        component: () => import(/* webpackChunkName: "invoices-history-stamped" */ '../../../views/Admin/Invoices/History/StampedList.vue'),
      },
      {
        path: 'preinvoice',
        name: 'PreInvoiceList',
        redirect: { name: 'InvoicesHistoryRefactor' },
        component: () => import(/* webpackChunkName: "invoices-history-pre" */ '../../../views/Admin/Invoices/History/PreInvoiceList.vue'),
      },
      {
        path: 'autoinvoice',
        name: 'AutoInvoiceList',
        redirect: { name: 'InvoicesHistoryRefactor' },
        component: () => import(/* webpackChunkName: "invoices-history-auto" */ '../../../views/Admin/Invoices/History/AutoInvoiceList.vue'),
      },
      {
        path: 'canceled',
        name: 'CanceledInvoiceList',
        redirect: { name: 'InvoicesHistoryRefactor' },
        component: () => import(/* webpackChunkName: "invoices-history-canceled" */ '../../../views/Admin/Invoices/History/CanceledList.vue'),
      },
      {
        path: 'credit-notes',
        name: 'CreditNoteList',
        redirect: { name: 'InvoicesHistoryRefactor' },
        component: () => import(/* webpackChunkName: "invoices-history-credit-notes" */ '../../../views/Admin/Invoices/History/CreditNoteList.vue'),
      },
      {
        path: 'payrolls',
        name: 'PayrollsList',
        redirect: { name: 'InvoicesHistoryRefactor' },
        component: () => import(/* webpackChunkName: "invoices-history-payrolls" */ '../../../views/Admin/Invoices/History/PayrollsList.vue'),
      },
      {
        path: 'saleNotes',
        name: 'SaleNoteList',
        redirect: { name: 'InvoicesHistoryRefactor' },
        component: () => import(/* webpackChunkName: "invoices-history-saleNote" */ '../../../views/Admin/Invoices/History/SaleNoteList.vue'),
      },
      {
        path: 'salaryReceipts',
        name: 'SalaryReceiptList',
        redirect: { name: 'InvoicesHistoryRefactor' },
        component: () => import(/* webpackChunkName: "invoices-history-salaryReceipt" */ '../../../views/Admin/Invoices/History/SalaryReceiptList.vue'),
      },
      {
        path: 'reps',
        name: 'RepList',
        redirect: { name: 'InvoicesHistoryRefactor' },
        component: () => import(/* webpackChunkName: "rep-payrolls" */ '../../../views/Admin/Invoices/History/RepList.vue'),
      },
    ],
  },
  {
    path: 'new-invoice',
    name: 'NewInvoice',
    component: () => import(/* webpackChunkName: "new-invoice" */ '../../../views/Admin/Invoices/NewInvoice.vue'),
    children: [
      {
        path: 'customer-searcher',
        name: 'NewInvoiceCustomerSearcher',
        component: () => import(/* webpackChunkName: "invoice-push-customer" */ '../../../views/Admin/Invoices/PushCustomer.vue'),
      },
    ],
  },
  {
    path: 'new-auto-invoice',
    name: 'NewAutoInvoice',
    component: () => import(/* webpackChunkName: "new-auto-invoice" */ '../../../views/Admin/Invoices/NewAutoInvoice.vue'),
    beforeEnter: guards.checkHaveEfirma,
  },
  {
    path: 'new-sale-note',
    name: 'NewSaleNote',
    component: () => import(/* webpackChunkName: "new-sale-note" */ '../../../views/Admin/Invoices/NewSaleNote.vue'),
  },
  {
    path: 'invoice/:uuid/detail',
    name: 'InvoiceDetail',
    component: () => import(/* webpackChunkName: "invoice-detail" */ '../../../views/Admin/Invoices/InvoiceDetail.vue'),
  },
  {
    path: 'credit-note',
    name: 'NewCreditNote',
    component: () => import(/* webpackChunkName: "credit-note" */ '../../../views/Admin/Invoices/CreditNote.vue'),
    beforeEnter: guards.checkHaveEfirma,
  },
  {
    path: 'credit-note/:uuid',
    name: 'CreditNoteDetail',
    component: () => import(/* webpackChunkName: "credit-note" */ '../../../views/Admin/Invoices/CreditNote.vue'),
    beforeEnter: guards.checkHaveEfirma,
  },
  {
    path: 'new-credit-note',
    redirect: { name: 'NewCreditNote' },
  },
  {
    path: 'credit-note/:uuid/detail',
    redirect: { name: 'CreditNoteDetail' },
  },
  {
    path: 'sale-note/:uuid/detail',
    name: 'SaleNoteDetail',
    component: () => import(/* webpackChunkName: "invoice-detail" */ '../../../views/Admin/Invoices/SaleNoteDetail.vue'),
  },
  {
    path: 'salary-receipt/:uuid/detail',
    name: 'SalaryReceiptDetail',
    component: () => import(/* webpackChunkName: "invoice-detail" */ '../../../views/Admin/Invoices/SalaryReceiptDetail.vue'),
  },
  {
    path: 'payroll/:uuid/detail',
    name: 'PayrollDetail',
    component: () => import(/* webpackChunkName: "payroll-detail" */ '../../../views/Admin/Invoices/PayrollDetail.vue'),
  },
  {
    path: 'customers/edit-customer/:customer(\\d+)',
    name: 'CustomerEdit',
    component: () => import(/* webpackChunkName: "customer-edit" */ '../../../views/Admin/Customers/Edit.vue'),
  },
  {
    path: 'customers',
    name: 'Customers',
    component: () => import(/* webpackChunkName: "customers" */ '../../../views/Admin/Customers/index.vue'),
    children: [
      {
        path: 'push-customer',
        name: 'CustomerPush',
        component: () => import(/* webpackChunkName: "customer-push" */ '../../../views/Admin/Customers/Push.vue'),
      },
      {
        path: 'bulk-upload',
        name: 'CustomerBulkUpload',
        component: () => import(/* webpackChunkName: "customer-bulk-upload" */ '../../../views/Admin/Customers/BulkUpload.vue'),
      },
      {
        path: 'bulk-upload-status',
        name: 'BulkLoadStatus',
        component: () => import(/* webpackChunkName: "customer-bulk-upload-status" */ '../../../views/Admin/Customers/BulkLoadStatus.vue'),
      },
      {
        path: 'delete-customer/:customer(\\d+)',
        name: 'CustomerDelete',
        component: () => import(/* webpackChunkName: "customer-delete" */ '../../../views/Admin/Customers/Delete.vue'),
      },
      {
        path: ':customer(\\d+)/status-account/delete/:company(\\d+)',
        name: 'StatusAccountDelete',
        component: () => import(/* webpackChunkName: "customer-status-account-delete" */ '../../../views/Admin/Customers/StatusAccountDelete.vue'),
      },
      {
        path: 'chat-customer/:customer(\\d+)/:company(\\d+)',
        name: 'CustomerChat',
        component: () => import(/* webpackChunkName: "customer-push" */ '../../../views/Admin/Customers/Chat.vue'),
      },
    ],
  },
  {
    path: 'employees',
    name: 'Employees',
    component: () => import(/* webpackChunkName: "employees" */ '../../../views/Admin/Employees/index.vue'),
    children: [
      {
        path: 'push-employee',
        name: 'EmployeePush',
        component: () => import(/* webpackChunkName: "employee-push" */ '../../../views/Admin/Employees/Push.vue'),
      },
      {
        path: 'bulk-upload',
        name: 'EmployeeBulkUpload',
        component: () => import(/* webpackChunkName: "employee-bulk-upload" */ '../../../views/Admin/Employees/BulkUpload.vue'),
      },
      {
        path: 'bulk-upload-status',
        name: 'EmployeeBulkLoadStatus',
        component: () => import(/* webpackChunkName: "employee-bulk-upload-status" */ '../../../views/Admin/Employees/EmployeeBulkLoadStatus.vue'),
      },
      {
        path: 'edit-customer/:employee(\\d+)',
        name: 'EmployeeEdit',
        component: () => import(/* webpackChunkName: "employee-edit" */ '../../../views/Admin/Employees/Edit.vue'),
      },
      {
        path: 'delete-customer/:employee(\\d+)',
        name: 'EmployeeDelete',
        component: () => import(/* webpackChunkName: "employee-delete" */ '../../../views/Admin/Employees/Delete.vue'),
      },
    ],
  },
  {
    path: 'new-payroll',
    name: 'NewPayroll',
    component: () => import(/* webpackChunkName: "new-payroll" */ '../../../views/Admin/Payrolls/NewPayroll.vue'),
    beforeEnter: guards.checkHaveEfirma,
    children: [
      {
        path: 'push-employee',
        name: 'PushEmployee',
        component: () => import(/* webpackChunkName: "push-employer" */ '../../../views/Admin/Payrolls/PushEmployee.vue'),
      },
    ],
  },
  {
    path: 'new-salary-receipt',
    name: 'NewSalaryReceipt',
    component: () => import(/* webpackChunkName: "new-salary-receipt" */ '../../../views/Admin/Payrolls/NewSalaryReceipt.vue'),
    children: [
      {
        path: 'push-basic-employee',
        name: 'PushBasicEmployee',
        component: () => import(/* webpackChunkName: "push-basic-employer" */ '../../../views/Admin/Payrolls/PushBasicEmployee.vue'),
      },
    ],
  },
  {
    path: 'secondary-users',
    name: 'SecondaryUsers',
    component: () => import(/* webpackChunkName: "secondary-users" */ '../../../views/Admin/SecondaryUsers/index.vue'),
    children: [
      {
        path: 'push',
        name: 'SecondaryUserPush',
        component: () => import(/* webpackChunkName: "push-secondary-user" */ '../../../views/Admin/SecondaryUsers/SecondaryUserPush.vue'),
      },
      {
        path: 'edit/:secondaryId(\\d+)',
        name: 'SecondaryEdit',
        component: () => import(/* webpackChunkName: "employee-edit" */ '../../../views/Admin/SecondaryUsers/Edit.vue'),
      },
      {
        path: 'delete/:secondaryId(\\d+)',
        name: 'SecondaryDelete',
        component: () => import(/* webpackChunkName: "employee-delete" */ '../../../views/Admin/SecondaryUsers/Delete.vue'),
      },
    ],
  },
];
